"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _pixelToNumber = _interopRequireDefault(require("../../style/pixelToNumber"));

var _scrollbar = _interopRequireDefault(require("../../style/scrollbar"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(theme, props, state) {
  var _theme = theme,
      palette = _theme.palette,
      maxLength = props.maxLength,
      virtualized = props.virtualized,
      error = props.error,
      disabled = props.disabled,
      readOnly = props.readOnly,
      inline = props.inline;
  var lineHeight,
      fieldBorder = {};

  if (typeof theme.lineHeight === 'number') {
    lineHeight = (0, _pixelToNumber["default"])(theme.fontSize) * theme.lineHeight;
  } else {
    lineHeight = (0, _pixelToNumber["default"])(theme.lineHeight);
  }

  var selectHeight = lineHeight + (0, _pixelToNumber["default"])(theme.paddingBottom) + (0, _pixelToNumber["default"])(theme.paddingTop);
  var optionHeight = lineHeight + (0, _pixelToNumber["default"])(theme.listItemPaddingTop !== undefined ? theme.listItemPaddingTop : theme.paddingTop) + (0, _pixelToNumber["default"])(theme.listItemPaddingBottom !== undefined ? theme.listItemPaddingBottom : theme.paddingBottom);

  if (!virtualized && !isNaN(maxLength)) {
    theme.listMaxHeight = optionHeight * maxLength + 'px';
  }

  theme = _objectSpread({}, theme, {
    color: theme.hoverColor,
    borderColor: theme.idleBorderColor,
    borderStyle: theme.idleBorderStyle,
    borderWidth: theme.idleBorderWidth,
    borderTransform: theme.idleBorderTransform,
    borderRadius: theme.idleBorderRadius,
    background: theme.idleBackground,
    boxShadow: theme.idleBoxShadow,
    outline: theme.idleOutline
  });

  if (state.hover) {
    theme = _objectSpread({}, theme, {
      color: theme.hoverColor,
      borderColor: theme.hoverBorderColor,
      borderStyle: theme.hoverBorderStyle,
      borderWidth: theme.hoverBorderWidth,
      borderTransform: theme.hoverBorderTransform,
      borderRadius: theme.hoverBorderRadius,
      background: theme.hoverBackground,
      boxShadow: theme.hoverBoxShadow,
      outline: theme.hoverOutline
    });
  }

  if (state.active) {
    theme = _objectSpread({}, theme, {
      color: theme.focusColor,
      borderColor: theme.focusBorderColor,
      borderStyle: theme.focusBorderStyle,
      borderWidth: theme.focusBorderWidth,
      borderTransform: theme.focusBorderTransform,
      borderRadius: theme.focusBorderRadius,
      background: theme.focusBackground,
      boxShadow: theme.focusBoxShadow,
      outline: theme.focusOutline
    });
  }

  if (error) {
    theme = _objectSpread({}, theme, {
      color: theme.errorColor,
      borderColor: theme.errorBorderColor,
      borderStyle: theme.errorBorderStyle,
      borderWidth: theme.errorBorderWidth,
      borderTransform: theme.errorBorderTransform,
      borderRadius: theme.errorBorderRadius,
      background: theme.errorBackground,
      boxShadow: theme.errorBoxShadow,
      outline: theme.errorOutline
    });
  }

  if (disabled || readOnly) {
    theme = _objectSpread({}, theme, {
      color: theme.disabledColor,
      borderStyle: theme.disabledBorderStyle,
      borderColor: theme.disabledBorderColor,
      borderWidth: theme.disabledBorderWidth,
      borderTransform: theme.disabledBorderTransform,
      borderRadius: theme.disabledBorderRadius,
      background: theme.disabledBackground,
      boxShadow: theme.disabledBoxShadow,
      outline: theme.disabledOutline
    });
  }

  if (inline) {
    theme.display = 'inline-block';
  } // рамка со всех сторон, классический инпут
  // скрываем нижнюю границу, применяем стиль к инпуту напрямую


  var wrappedBorder = !/none/.test(theme.borderStyle);

  if (wrappedBorder) {
    fieldBorder = {
      borderStyle: theme.borderStyle,
      borderColor: theme.borderColor,
      borderWidth: theme.borderWidth
    };
    selectHeight += (0, _pixelToNumber["default"])(theme.borderWidth) * 2;
  }

  var scrollStyle = (0, _scrollbar["default"])(palette);
  return {
    root: {
      display: theme.display,
      width: theme.width,
      minWidth: theme.minWidth
    },
    wrapper: {
      position: 'relative',
      fontFamily: theme.fontFamily,
      color: theme.color
    },
    input: _objectSpread({
      position: 'relative',
      height: selectHeight + 'px',
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: 'ease',
      transitionProperty: 'transform, border-color',
      background: theme.background,
      boxShadow: theme.boxShadow,
      borderRadius: theme.borderRadius
    }, fieldBorder),
    multipleValueWrapper: {
      // not flex, because of text-overflow: ellipsis dont work with flex
      display: 'inline-block'
    },
    list: _objectSpread({
      // virtualized component adds his own overflow
      overflowY: virtualized ? 'hidden' : theme.listOverflowY,
      overflowX: theme.listOverflowX,
      maxHeight: theme.listMaxHeight,
      outline: '0 none',
      // фикс при раскрытии списка с max-height внутри
      // не понятно почему, контект прыгал с начала transition и становился на место в конце
      transform: 'translateZ(0)'
    }, scrollStyle, {
      // virtualized container. Have no access to override inner element style
      '& *': _objectSpread({}, scrollStyle, {
        outline: '0 none'
      })
    }),
    overlay: {
      paddingTop: palette.gutter + 'px',
      paddingBottom: palette.gutter + 'px',
      paddingLeft: 0,
      paddingRight: 0,
      background: theme.listBackground,
      border: '0 none',
      boxShadow: theme.listBoxShadow,
      zIndex: theme.listZIndex,
      overflow: 'hidden',
      outline: '0 none',
      minWidth: theme.listMinWidth
    },
    option: {
      height: optionHeight
    }
  };
}